import dClient from "../../Components/api/reduxLoaderApi";
import {setOrder} from "./slice";
import failStatus from "../../Components/utils/failStatus";


export const getOrderById = ({ id }, callback = false) => async (
    dispatch,
    getState,
) => {
    const res = await dClient(
        'get',
        `admin/order/${id}`,
        {},
        {},
        1,
        true,
    );
    if (failStatus(res, dispatch)) return '';
    dispatch(setOrder(res.data.order));
    return callback && callback(res.data.order);
};

export const changeOrderStatus = ({ id, status, is_nearby}, callback = false) => async (
    dispatch,
    getState,
) => {
    const res = await dClient(
        'post',
        `admin/order/change-status`,
        {
            order_id: id,
            status: status,
            is_nearby: is_nearby
        },
        {},
        1,
        true,
    );
    if (failStatus(res, dispatch)) return '';
    return callback && callback(res.data.topin_status);
};